import { css } from "@emotion/react";
import { bpoints } from "../../../../../Utils";

export function leasinInfoCSS() {
    return css`
    width: 70%;
    margin: 0 auto;

    @media (max-width: ${bpoints.mobile.w}px) {
        width: 100%;
        // .ComplementInfo{
        //     width: 80% !important;
        // }
    }

    .ComplementInfo{
            margin-top:1rem;
        }

    .Input{
        width: 300px;
        text-transform: uppercase;
    }

    .Input[name="email"], .Input[name="email2"] {
        text-transform: none !important;
    }

    .ChooseTypePersonBtn{
        display: flex;
        gap: 1rem;
    }

    

    .Disclaimer{
      color: #77787B;
      font-family: 'Neue Haas Grotesk Display Pro';
      font-size: calc(0.5rem + 0.5vw);
      font-style: normal;
      font-weight: 500;
      text-align: justify;
      //line-height: 20px; /* 125% */
    }

    .TopText{
        width: 90%;
    }

    
 .TextContainer {
      display: flex;
      flex-direction: column;
      z-index: 1;

      //margin-top: calc(1rem + 1.5vh);

      text-align: center;

      font-size: calc(10px + 1vw);

      /* background: linear-gradient(90deg, #204B7B 0%, #32B8DF 31.04%, #00BA6E 100%); */
      background: #204b7b;
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      @media (max-width: ${bpoints.mobile.w}px) {
        padding: 0 10%;
        font-size: calc(16px + 1vw);

        span {
          display: contents;
        }
      }
    }
    .ExtraInfo {
    font-size: calc(16px + (18 - 16) * ((100vw - 320px) / (1920 - 320))); /* Tamaño del texto adicional */
    color: #888; /* Color más discreto */
    // margin-left: 5px; /* Espacio entre el texto principal y el texto adicional */
}

.ContainetBtn{
    width: 60%;
    justify-content: center;
    min-width: 200px;
    display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
}

        @media (max-width: ${bpoints.mobile.w}px) {
        .ContainetBtn{
            width: 100%;
            align-items: center;
        }
        }


    .ButtonSection2 {
      margin:auto;
      display: flex;
      flex-direction: column;
      gap: 5.2vh;
      align-items: center;
      width: 100%;

      .TextRow {
        display: flex;
        flex-direction: column;
        text-align: center;

        .NormalMedium {
          font-size: calc(1.1rem + 0.8vw);
          font-style: normal;
          font-weight: 500;
          line-height: 105.405%;

          @media (max-width: ${bpoints.mobile.w}px) {
            font-size: calc(1.5rem + 4.5vw);
            padding: 0 1.2rem;
          }
        }

        
      }

      .ButtonRow {
        width: calc(9rem + 28vw);
        display: flex;
        gap: calc(2rem + 1vw);
        color: white;
        font-weight: 500;
        font-size: calc(1.1rem + 0.6vw);
        letter-spacing: 0.74px;
        justify-content: center;


        @media (max-width: ${bpoints.mobile.w}px) {
          flex-direction: column;
          gap: 15px;
          font-size: calc(1.3rem + 1.5vw);
          width: 70%;
        }

      
        .Button {
          position: relative;
          cursor: pointer;
          border-radius: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;

          padding: 1.5rem 0;

          flex-basis: 0;
          flex-grow: 1;

          //transition: 300ms;
        }

        .Green {
          background-color: #22ec9a;
          :hover {
            background-color: #2ad690;
          }
        }

        .Blue {
          background-color: #32b8df;
        }

        .GradientLeft {
          border: none;
          outline: none;
          background: linear-gradient(to right, #34c6f1, #00ba6e);
          z-index: 1;
          //transition: 200ms;
          min-height: 94px;

          :hover {
            background: #22ec9a;
          }

          ::before {
            content: "";
            position: absolute;
            left: 2px;
            right: 2px;
            top: 2px;
            bottom: 2px;
            border-radius: 23px;
            background-color: white;
            z-index: -1;
            transition: 200ms;
          }

          ::after {
            content: attr(data);

            color: #00ba6e;
            transition: 200ms;
          }
        }

        .GradientLeft:hover::before {
          background-color: #22ec9a;
        }

        .GradientLeft:hover::after {
          color: #fff;
        }

        .GradientRight {
          border: none;
          outline: none;
          background: linear-gradient(to left, #34c6f1, #00ba6e);
          z-index: 1;

          :hover {
            background: #32b8df;
          }

          ::before {
            content: "";
            position: absolute;
            left: 2px;
            right: 2px;
            top: 2px;
            bottom: 2px;
            border-radius: 23px;
            background-color: white;
            z-index: -1;
            transition: 200ms;
          }

          ::after {
            content: attr(data);

            color: #21588c;
            transition: 200ms;
          }
        }

        .GradientRight:hover::before {
          background-color: #32b8df;
        }

        .GradientRight:hover::after {
          color: #fff;
        }
      }

      .Shadow {
        margin-top: -1rem;
        border-radius: 837px;
        background: radial-gradient(
          50.94% 44.66% at 49.86% 50.14%,
          rgba(0, 0, 0, 0.12) 0%,
          rgba(217, 217, 217, 0) 100%
        );
        width: calc(9rem + 28vw);
        height: 3rem;
      }

     .Button{
        cursor: pointer;
        border-radius: 25px;
        display: flex;
        justify-content: center;
        align-items: cent
        padding: 1.5rem 0;
    
        flex-basis: 0;
        flex-grow: 1;
                            
        transition: 300ms;

        @media (max-width: ${bpoints.mobile.w}px){
            padding: 1rem 0;

        }
    }
    
    .Green {
          background-color: #1fdd8f;
          color: white;
          font-size: calc(0.4rem + 0.7vw);
          border-radius: 17px !important;
          border: unset !important;

          width: fit-content;
          padding: 0 3rem;
          :hover {
            background-color: #2ad690;
          }
        }
    
    .withoutSelected{
     background-color: transparent !important;
          color: black !important;
          font-size: calc(0.4rem + 0.7vw);
          border-radius: 17px !important;
          border: unset !important;

          width: fit-content;
          padding: 0 3rem;
          :hover {
            background-color: #2ad690;
          }
        :hover{
            background-color: #1fdd8f !important;
            color: white !important;
        }
    }
    
    .Blue{
        background-color: #32B8DF;
          color: white;
          font-size: calc(0.4rem + 0.7vw);
          border-radius: 17px !important;
          border: unset !important;

          width: fit-content;
          padding: 0 3rem;
          :hover {
            background-color: #2ad690;
          }
        :hover{
            background-color: #2da5c8;
        }
    }
    }
    `;
}